import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.widgetRendering.DOC}
  query MosaicWidgetPreview(
    $tenantId: ID!
    $zoneId: ID!
    $widgetIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          widgetPreview(identifier: $widgetIdentifier) {
            ...FragmentMosaicWidgetRendering
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicWidgetPreviewQuery,
  Omit<ents.core.mosaic.Widget.Rendering, 'variables'> | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select(
        'widgetPreview',
        fragments.widgetRendering.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.MosaicWidgetPreviewQuery,
  Omit<ents.core.mosaic.Widget.Rendering, 'variables'> | undefined,
  graphql.schema.MosaicWidgetPreviewQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
